// removed by extract-text-webpack-plugin
module.exports = {"Rating":"_OhAY5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hotel/HotelTuple/HotelTuple.scss
// module id = 894
// module chunks = 0